import React from 'react'
import { Container } from '../../../components'
import { Card } from './index'
import auth from '../../../utils/auth'

const PageHeader = ({data}) => {
  const { isOfficial, isVerified } = auth()

  return (
    <div
      className="page-header bg-center bg-cover bg-no-repeat"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.25)',
        backgroundImage: `url('${data.cover}')`,
        backgroundBlendMode: 'multiply'
      }}
    >
      <Container
        className={`py-8 lg:py-20 ${isOfficial ? 'official' : isVerified ? 'verified' : ''}`}
      >
        <Card data={
          {
            name: data.name,
            image: data.logo,
          }
        }/>
      </Container>
    </div>
  )
}

export { PageHeader }
